import React from "react";
import { Link } from "react-router-dom";

import Icon from "components/Icon";
import { gameTypes } from "domain/GamesSearch/types";

const PrivateGameError = ({ gameType }) => {
    return (
        <section
            className="card-full content"
            style={{ "--bg-image": `url(${gameType.image_url})` }}
        >
            <div className="card-full__head">
                <div className="card-full__back">
                    <Link to="/" className={`icon-container`}>
                        <Icon type={`back`} inheritColor />
                    </Link>
                </div>

                <div className="card-full__top">
                    <h2 className="card-full__title">{gameType.name}</h2>
                </div>

            </div>
            <div className="card-full__body">
                <div className="page__info">
                    <p className="text-center c-gs-medium-em">
                        Это закрытая игра. Вы не можете посмотреть информацию о
                        ней и принять участие.
                    </p>
                </div>
            </div>
        </section>
    );
};

PrivateGameError.propTypes = {
    gameType: gameTypes,
};

export default PrivateGameError;
